module.exports = __webpack_public_path__ + "894a76f267b1cd31ea91548f02e9abc7.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2018-04-12/whats-new.html
// module id = 2286
// module chunks = 0